export const RegionKeys = {
  US: 'us',
  EU: 'eu',
  AU: 'au',
  JP: 'jp',
  SG: 'sg',
  CA: 'ca',
} as const;

export type Region = typeof RegionKeys[keyof typeof RegionKeys];
